import { useQuery } from '@tanstack/react-query';
import { OfficeStatus } from 'chaika-enums';

import { officeQueryOptions } from '@services/queries/officeQueries';
import { store } from '@store';
import { useOfficeScheduleSettings } from '@modules/clinics/ui/ClinicPage/hooks/useOfficeScheduleSettings';

import { hasClinicsAccess } from '../utils/hasClinicsAccess';

interface Data {
    hasAccess: boolean;
    isResolved: boolean;
}

export function useClinicsAccess(): Data {
    const { authUser } = store;
    const isPrivileged =
        authUser.isHeadOfClinic || authUser.hasRootAccess || authUser.isPracticeLeader || authUser.isAssistant;
    const organizationId = authUser.organizationId;

    const { data: offices = [], isLoading: isOfficesLoading } = useQuery({
        ...officeQueryOptions.list({
            organizationId: organizationId ? [organizationId] : [],
            status: OfficeStatus.Active,
        }),
        enabled: !isPrivileged && !!organizationId,
    });
    const officeIds = offices.map(office => office.id);
    const { settingsByOffice, isLoading: isSettingsLoading } = useOfficeScheduleSettings({ officeIds });

    return {
        hasAccess: hasClinicsAccess({
            isHeadOfClinic: authUser.isHeadOfClinic,
            hasRootAccess: authUser.hasRootAccess,
            isPracticeLeader: authUser.isPracticeLeader,
            isAssistant: authUser.isAssistant,
            currentUserId: authUser.id,
            organizationId,
            offices,
            settingsByOffice,
        }),
        isResolved: isPrivileged || (!isOfficesLoading && !isSettingsLoading),
    };
}
